import { Input, Label } from "@monbits/ui";
import type * as React from "react";

interface Props {
	placeholder: string;
	label: string;
	name: string;
	required: boolean;
	value?: string;
	onChange?: (value: string) => void;
	error?: string;
}

const urlPattern =
	/^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;

const linkPrefix = "https://";

export const validateUrl = (value: string, required: boolean): boolean => {
	if (!value && !required) {
		return true;
	}
	return urlPattern.test(linkPrefix + value);
};

const LinkInput: React.FC<Props> = (props: Props) => {
	return (
		<div className="space-y-2">
			<Label htmlFor={props.name}>
				{props.label}
				{props.required && <span className="text-destructive ml-1">*</span>}
			</Label>
			<div className="flex w-full">
				<div className="inline-flex items-center px-3 text-sm text-muted-foreground bg-muted border border-r-0 border-input rounded-l-md">
					https://
				</div>
				<Input
					id={props.name}
					name={props.name}
					placeholder={props.placeholder}
					value={props.value}
					onChange={(e) => props.onChange?.(e.target.value)}
					className="rounded-l-none"
				/>
			</div>
			{props.error && (
				<p className="text-sm font-medium text-destructive">{props.error}</p>
			)}
		</div>
	);
};

export default LinkInput;
